import { render, staticRenderFns } from "./ExchangeAddOrEdit.vue?vue&type=template&id=51758412&"
import script from "./ExchangeAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./ExchangeAddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeAddOrEdit.vue?vue&type=style&index=0&id=51758412&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports